export const EmbedStyle = Object.freeze({
  NONE: { key: 'none', name: 'None' },
  PAGE: { key: 'page', name: 'Page' },
  PANEL: { key: 'panel', name: 'Panel' },
})

export const LOCAL_STORAGE_OVERRIDES_KEY = 'launch_darkly_overrides'

export const API_BASE_URL = process.env.REACT_APP_AWSAPIGATEWAY;

export const REDIRECT_URLS = {
  dev: 'https://local.backlotclub.com',
  stage: 'https://epic-universe-stage.backlot.club',
  uat: 'https://epic-universe-uat.backlotclub.com',
  prod: 'https://epic-universe.backlot.club'
};

/* Change me */
export const env = 'prod'; //update
export const aptos_network = 'mainnet';
export const CODE_API_BASE_URL = API_BASE_URL;